import React from 'react';

function Dashboard() {
  return (
    <div>
      <h1 className="text-2xl font-light text-gray-800 mb-6">대시보드</h1>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
        <p className="text-gray-600 leading-relaxed">
          제주로부터 관리자 페이지입니다.
          <br />
          왼쪽 메뉴에서 필요한 기능을 선택하세요.
        </p>
      </div>
    </div>
  );
}

export default Dashboard;
